import { useMemo } from "react";
import { ReservationOrderItemInfo } from "../../../../model/Reservation/OrderItem";
import { ReservationExpendedListForm } from "./List";
import { ExpendedContainer } from "./index.styled";

interface ReservationExpendedInfoProps {
  record: any;
}

export const ReservationExpendedInfo: React.FC<
  ReservationExpendedInfoProps
> = ({ record }) => {
  const reducer = (a: any, b: ReservationOrderItemInfo) => {
    const productType = b.productType === "ETC" ? "TIRE" : b.productType;
    if (!a[productType]) a[productType] = [];
    a[productType].push(b);

    return a;
  };

  const list = useMemo(() => {
    if (record && record.orderItems) {
      return record.orderItems.reduce(reducer, {});
    }

    return {};
  }, [record]);

  return (
    <ExpendedContainer style={{ padding: 0 }}>
      <ReservationExpendedListForm
        orderItems={record?.orderItems as ReservationOrderItemInfo[]}
      />
      {/* {Object.keys(list).map((key: string) => (
        <ProductsCard key={`orderItem-${record.id}:${key}`} item={list[key]} />
      ))} */}
    </ExpendedContainer>
  );
};
